import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Award1, Award2, Award3, Award4, DefaultBlot, EllipseImage } from 'src/assets';
import './rewards.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const Rewards = () => {
  const { t } = useTranslation();

  const rewardsData = [
    {
      id: '1',
      logo: Award1,
    },
    {
      id: '2',
      logo: Award2,
    },
    {
      id: '3',
      logo: Award3,
    },
    {
      id: '4',
      logo: Award4,
    },
  ];

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="rewards">
      <div className={`rewards-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="rewards-title">
          <supertitle className="rewards-supertitle">{t('rewards:supertitle')}</supertitle>
          <h1 className="rewards-title-heading">{t('rewards:rewards')}</h1>
          <div className="rewards-title-subtitle">{t('rewards:subtitle')}</div>
        </div>

        <div className="rewards-awards">
          {rewardsData.map((item) => (
            <img key={item.id} src={item.logo} alt={item.logo} />
          ))}
        </div>

        <img src={EllipseImage} alt={EllipseImage} className="rewards-image-1" />
        <img src={DefaultBlot} alt={DefaultBlot} className="rewards-image-2" />
      </div>
    </div>
  );
};
